module.exports = __webpack_public_path__ + "media/images/LeftFaq-e643ebc60483a7d30c1af67d0b87cf53.png";